export default __webpack_public_path__ + "static/media/subscribe.efb3c030.webp";